<template>
  <el-form ref="form" label-position="top" :model="form" :rules="rules" label-width="120px" class="app-container view-container">
    <BjDivider>
      {{ $t('CustomerFunction.common.AddReturnItem') }}
      <template slot="right">
        <el-button @click="tryCancel">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="onConfirm">{{ $t('okText') }}</el-button>
      </template>
    </BjDivider>
    <template>
      <el-row :gutter="10">
        <el-col span="6" v-if="!$store.getters.cusId">
          <el-form-item :label="$t('billingPage.CustomerName')" prop="clientCode">
            <BjSelectLov v-model="form.clientCode" :option-list="clientCodeList" @change="cusChange" />
          </el-form-item>
        </el-col>
        <el-col span="6">
          <el-form-item :label="$t('CustomerFunction.common.logisticsNo')">
            <BjInput v-model="form.logisticsNumber" type="text" :placeholder="$t('inputText')" clearable />
          </el-form-item>
        </el-col>
        <el-col span="6">
          <el-form-item :label="$t('CustomerFunction.common.associatedCode')" prop="">
            <el-input v-model="form.associatedCode" :placeholder="$t('chooseText')" :clearable="true" @input="handleInput" @focus="handleShowFnForDialogOrderList"></el-input>
          </el-form-item>
        </el-col>
        <el-col span="6">
          <el-form-item :label="$t('BusinessAfterCsgReturn.main.thirdOrder')" prop="">
            <el-input v-model="form.platformNo" :placeholder="$t('inputText')" :clearable="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </template>

    <div class="bj-row mt20">
      <BjDivider>{{ $t('AddingAnInternalReturnRefundDoc.Product') }}
        <template>
          <el-button type="primary" @click="handleShowFnForDialogSkuList">{{$t('BusinessAfterCsgReturn.table.add')}}</el-button>
        </template>
      </BjDivider>
      <div class="bj-col bj-col-24" style="border-left:none">
        <el-table :data="form.applySkuList" border script max-height="600px">
          <el-table-column :label="$t('table.countText')" type="index" width="55" align="center" />
          <el-table-column prop="standardSkuCode" label="SKU" align="center" />
          <el-table-column prop="barCode" :label="$t('BusinessPurchaseDetailPage.table.Barcode')" align="center" />
          <el-table-column align="center">
            <template #header>
              <span class="red">*</span> {{ $t('UploadTotalText') }}
            </template>
            <template v-slot="{ row }">
              <BjInputNumber v-model="row.returnTotal" class="full-width" clearable :controls="false" />
            </template>
          </el-table-column>
          <el-table-column align="center">
            <template #header>
              <span class="red">*</span> {{ $t('CustomerFunction.table.GoodQuality') }}
            </template>
            <template v-slot="{ row }">
              <BjSelectLov v-model="row.nonDefectiveHandling" :disabled="!$store.getters.cusId" :option-list=" CSG_RETURN_LIST_ADMIN_STATUS" :clearable="false"/>
            </template>
          </el-table-column>
          <el-table-column align="center">
            <template #header>
              <span class="red">*</span> {{ $t('CustomerFunction.table.HandlingOf') }}
            </template>
            <template v-slot="{ row }">
              <BjSelectLov v-model="row.defectiveHandling" :disabled="!$store.getters.cusId" :option-list="CSG_RETURN_LIST_ADMIN_STATUS" :clearable="false"/>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.operationText')" fixed="right" align="center" width="110">
            <template v-slot="{ $index }">
              <el-button @click="onDelete($index)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <BjDialogList ref="BjDialogOrderList" width="80%" :config="$BjDialogListConfig.thirdOrderDefault($t('AddAThirdPartyAfterSalesOrder.associated'), { defaultQuery: { totalOrderStatus: [5], cusId: this.form.cusId } })" tag-name="outerOrderNo" @confirm="confirmForDialogOrderList" />
    <BjDialogList ref="dialogList" :colSpan="8" :config="$BjDialogListConfig.skuDefault('SelectSKUText', { defaultQuery: defaultQuery, columns: columns, search: search, actionApi: actionApi })" @confirm="onAddDialogConfirm" multiple />
  </el-form>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { goodsApi, userApi, orderApi, funConfigApi } from '@/api';
import {  CSG_RETURN_LIST_ADMIN_STATUS } from '@/utils/constants';
export default {
    name: 'BusinessAfterReturnAdd',
    mixins: [viewMiXin],
    data() {
        return {
            CSG_RETURN_LIST_ADMIN_STATUS,
            colSpan: 8,
            form: {
                customName: `${this.$store.getters.userInfo.loginName}(${this.$store.getters.userInfo.companyName	})` || null,
                logisticsNumber: null,
                associatedCode: null,
                clientCode: this.$store.getters.userInfo.clientCode || null,
                applySkuList: [],
                cusId: this.$store.getters.cusId || null
            },
            CUSTOMER_LIST: [],
            actionApi: goodsApi.getSku,
            defaultQuery: {
                status: [1, 2, 3, 4, 5]
            },
            columns: [
                {
                    prop: 'standardSkuCode',
                    label: 'BjDialogListConfig.SKUcode',
                    width: 160,
                },
                {
                    prop: 'skuName',
                    label: 'BjDialogListConfig.SKUname',
                    width: 160,
                },
                {
                    prop: 'barCode',
                    label: this.$t('BusinessPurchaseDetailPage.table.Barcode'),
                    width: 160,
                },
            ],
            search: [
                {
                    placeholder: `${this.$t('BjDialogListConfig.entername')}、${this.$t('BjDialogListConfig.Codes')}、${this.$t('BusinessPurchaseDetailPage.table.Barcode')}`,
                    key: 'keyword',
                },
            ],
            rules: {
                'clientCode': [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
            },
            config:{
                nonDefectiveHandling: '',
                defectiveHandling: '',
            }
        };
    },
    computed: {
      clientCodeList() {
        return this.$store.getters.clientCodeList;
      }
    },
    mounted() {
      if(this.$store.getters.cusId){
        funConfigApi.queryUserConfiguration({clientCode: this.form.clientCode}).then(res=>{
          if(res.length>0){
              res.forEach(item =>{
                  if(item.configKey == "How to Handle Non-Conforming Products"){
                      this.config.defectiveHandling = String(item.configValue)
                  }else if(item.configKey == "How to handle quality products"){
                      this.config.nonDefectiveHandling = String(item.configValue)
                  }
              })
          }
        })
      }
    },
    methods: {
        handleInput(){
          this.form.associatedCode = ''
        },
        handleShowFnForDialogOrderList() {
          if (this.form.cusId) {
            this.$refs.BjDialogOrderList.show();
          } else {
              this.$message.warning(this.$t('BusinessAfterCsgReturn.hintMessageText1'));
          }
        },
        confirmForDialogOrderList(data) {
            this.form.associatedCode = data[0].sapOrderNo;
        },

        cusChange(e, item) {
          console.log(333, e, item)
            if (!item.label) return;
            this.form.customName = item.label;
            this.form.cusId = item.cusId
            funConfigApi.queryUserConfiguration({clientCode: item.value}).then(res=>{
                if(res.length>0){
                    res.forEach(item =>{
                        if(item.configKey == "How to Handle Non-Conforming Products"){
                            this.config.defectiveHandling = String(item.configValue)
                        }else if(item.configKey == "How to handle quality products"){
                            this.config.nonDefectiveHandling = String(item.configValue)
                        }
                    })
                }
            })
        },
        // 添加商品
        async onAddDialogConfirm(data) {
            if (!data) return;
            data.forEach(async(item) => {
                if (!this.form.applySkuList.find(ee => ee.standardSkuCode == item.standardSkuCode)) {
                    this.form.applySkuList.push({
                        sku: item.skuCode,
                        standardSkuCode: item.standardSkuCode,
                        barCode: item.barCode,
                        returnTotal: '',
                        nonDefectiveHandling: this.config.nonDefectiveHandling,
                        defectiveHandling: this.config.defectiveHandling
                    });
                }
            });

        },
        handleShowFnForDialogSkuList() {
            if (this.form.cusId) {
                this.defaultQuery['cusId'] = this.form.cusId;
                this.$nextTick(() => {
                    this.$refs.dialogList.show();
                });
            }else {
                this.$message.warning(this.$t('BusinessAfterCsgReturn.hintMessageText1'));
            }
        },
        onDelete(index) {
            this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
                confirmButtonText: this.$t('toast.okText'),
                cancelButtonText: this.$t('toast.cancelText'),
                type: 'warning',
            }).then(() => {
               this.form.applySkuList.splice(index, 1)
            })
        },
        onConfirm() {
            this.$refs.form.validate(valid => {
                if(valid){
                    if (!this.form.applySkuList.length) return this.$message.error(this.$t('BusinessAfterCsgReturn.hintMessageText2'));
                    for (const item of this.form.applySkuList) {
                        if (!item.returnTotal || !item.nonDefectiveHandling || !item.defectiveHandling) {
                            return this.$message.error(this.$t('BusinessAfterCsgReturn.hintMessageText4'));
                        }
                    }
                    this.addApi();
                }
            });
        },
        addApi() {
            orderApi.add(this.form).then(res => {
                if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
                    this.$message.success(this.$t('toast.operationSuccessText'));
                    setTimeout(() => {
                        this.complete('BusinessOpenReturnList');
                    }, 500);
                }
            });
        },
    },
};
</script>